import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthManager } from './auth.service';
import { StorageKeys } from '@core-interfaces/global';

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {
  constructor(
    private authManager: AuthManager,
    private router: Router
  ) {}

  /**
   * Initialize the application and check authentication status
   */
  initializeApp(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const publicRoutes = ['/login', '/recover-password', '/new-password'];
      const currentUrl = window.location.href;

      const isPublicRoute = publicRoutes.some(route => currentUrl.includes(route));

      if (isPublicRoute) {
        return resolve(true);
      }

      const token = localStorage.getItem(StorageKeys.session_token);

      if (!token) {
        this.router.navigate(['/login']);
        return resolve(true);
      }

      // We have a token, check if it's valid
      if (this.authManager.isAuth()) {
        try {
          const userData = this.authManager.UserSessionData();
          if (userData) {
            // Token is valid, check if it's expired
            const now = new Date();
            const expDate = new Date(userData.exp * 1000);
            if (now > expDate) {
              // Token is expired, remove it and go to login
              this.authManager.cleanSession();
              this.router.navigate(['/login']);
              resolve(true);
            }
            resolve(true);
          } else {
            // Token is invalid, remove it and go to login
            this.authManager.cleanSession();
            this.router.navigate(['/login']);
            resolve(true);
          }
        } catch (error) {
          console.error('Error validating token:', error);
          this.authManager.cleanSession();
          this.router.navigate(['/login']);
          resolve(true);
        }
      } else {
        // No valid auth, go to login
        this.router.navigate(['/login']);
        resolve(true);
      }
    });
  }
}
